import { render, staticRenderFns } from "./PeopleSeiji.vue?vue&type=template&id=451eb09a&scoped=true&"
import script from "./PeopleSeiji.vue?vue&type=script&lang=js&"
export * from "./PeopleSeiji.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSeiji.vue?vue&type=style&index=0&id=451eb09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451eb09a",
  null
  
)

export default component.exports